import { validPhoneRegex } from 'shared/validators/phone.validator';
import * as yup from 'yup';

// Validator for Organizer form values used in Formik (UI-level shape)
// Notes:
// - Keeps validation minimal and non-blocking: required name and sport type; optional email/phone with format checks.
// - Address and logo are optional and loosely validated to avoid blocking edits before user provides data.
// - Messages are in Russian to match the UI language used across the project.
export const organizerFormValidator = () =>
  yup
    .object({
      name: yup.string().trim().required('Введите название организации'),
      sportType: yup
        .object({
          label: yup.string().required(),
          value: yup.string().required('Выберите тип спорта'),
        })
        .required('Выберите тип спорта') as yup.AnyObjectSchema,
      email: yup
        .string()
        .trim()
        .nullable()
        .notRequired()
        .test('is-email', 'Некорректный email', (val) => !val || yup.string().email().isValidSync(val)),
      phone: yup
        .string()
        .trim()
        .nullable()
        .notRequired()
        .test('is-phone', 'Некорректный номер телефона', (val) => !val || validPhoneRegex.test(val)),
      address: yup.mixed().nullable().notRequired(),
      description: yup.string().nullable().notRequired(),
      logo: yup.array().nullable().notRequired(),
    })
    .required();

export default organizerFormValidator;
